import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'

import { API_ENDPOINT } from '../config'
import { getToken, removeToken } from './token-helper'
import { get } from 'lodash'
import { getHistory } from './history'

type responseError = {
  status: 'error'
  message: string
  error: string
}

type responseSuccess<T> = {
  status: 'success' | 'completed'
  payload: T
}

export type APIResponse<T> = responseError | responseSuccess<T>

// request data
export const fetch = async (
  route: string,
  data: any = '',
  method: AxiosRequestConfig['method'] = 'GET'
) => {
  const authOptions: AxiosRequestConfig = {
    data: data,
    headers: {
      'Content-Type': 'application/json',
    },
    method,
    url: `${API_ENDPOINT}/${route}`,
  }
  // do http request
  return axios(authOptions).then((res: AxiosResponse) => res.data)
}

// request data from token in localStorage
export const fetchWithToken = async <T = any>(
  route: string,
  data: any = {},
  method: AxiosRequestConfig['method'] = 'POST',
  token: string | null = ''
): Promise<T> => {
  const authOptions: AxiosRequestConfig = {
    data: JSON.stringify(data),
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': token || getToken(),
    },
    method,
    url: `${API_ENDPOINT}/${route}`,
  }
  // do http request
  try {
    const response = await axios(authOptions).then(
      (res: AxiosResponse) => res.data
    )
    // check error, if error = true and message = invalid access token
    // remove token from localStorage
    if (response.error && response.message === 'Authentication Error') {
      removeToken()
    }
    // return response data
    return response
  } catch (e) {
    if (get(e, 'response.status') === 401) {
      removeToken()
      getHistory().push('/')
    }
    return e as T
  }
}
